import type { ObservationInvalidationButtonProps } from "./observation-invalidation-button.type";

import { CloseCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

import { useInvalidateObservation } from "@/entities/observation";

const ObservationInvalidationButton = ({
  observationId,
  disabled,
  loading,
  invalidateKeys,
}: ObservationInvalidationButtonProps) => {
  const { t } = useTranslation();

  const { invalidate, isPending } = useInvalidateObservation(observationId, {
    invalidateKeys,
  });

  return (
    <Button
      icon={<CloseCircleOutlined />}
      loading={loading || isPending}
      onClick={invalidate}
      disabled={disabled}
    >
      {t("observation:validation.invalidate")}
    </Button>
  );
};

export default ObservationInvalidationButton;
